<template>
  <div class="home">
    <reporting-api pageName="home" :countdown="true">
      <template slot-scope="data">
        <b-row>
          <b-col md="4" sm="12">
            <h2>Summary</h2>
            <b-card 
              bg-variant="success"
              text-variant="white">
              <p class="card-text">
                Issues in the last {{ data.page.issueCount[0].num_of_days }} days
                <b-badge variant="light">{{ data.page.issueCount[0].report_count | commas }}</b-badge>
              </p>
              <p class="card-text">
                Outstanding issues for last {{ data.page.outstandingIssueCount[0].num_of_days }} days
                <b-badge variant="light">{{ data.page.outstandingIssueCount[0].report_count | commas }}</b-badge>
              </p>
              <p class="card-text">
                Pings in the last {{ data.page.pingCount[0].num_of_days }} days
                <b-badge variant="light">{{ data.page.pingCount[0].report_count | commas }}</b-badge>
              </p>
              <p class="card-text">
                Unique locations
                <b-badge variant="light">{{ data.page.uniqueLocations[0].location_count }}</b-badge>
              </p>
            </b-card>
          </b-col>
          <b-col md="4" sm="12">
            <h2>Restarted recently</h2>
            <b-card v-for="server in data.page.recentlyRestarted" :key="`recent-${server.location}`"
              :title="server.location"
              bg-variant="light"
              class="card-small">
              <p class="card-text">
                <i class="fas fa-plug"></i>&nbsp;
                <span v-b-tooltip.hover :title="dateForSecsAgo(server.uptime)"
                  >{{ humanDateForSecsAgo(server.uptime) }} ago at {{ dateForSecsAgo(server.uptime, true) }} GMT</span>
              </p>
            </b-card>
          </b-col>
          <b-col md="4" sm="12">
            <h2>Potentially offline?</h2>
            <b-card v-for="server in data.page.potentiallyOffline" :key="`offline-${server.location}`"
              :title="server.location"
              class="card-small"
              bg-variant="light">
              <p class="card-text">
                <i class="fas fa-power-off"></i>&nbsp;
                <span v-b-tooltip.hover :title="server.last_heard_from.value | moment('DD/MM/YYYY h:mm:ss a')"
                >{{ server.last_heard_from.value + 'Z' | moment('from', 'now') }}
                at {{ server.last_heard_from.value | moment('HH:mm:ss') }} GMT</span>
              </p>
            </b-card>
          </b-col>
        </b-row>
          
        <h2>Recent Errors</h2>
        <reports :reports="data.page.recentErrors"/>

      </template>
    </reporting-api>
  </div>
</template>

<script>
import * as moment from 'moment';
import ReportingApi from '../components/ReportingApi.vue';
import Reports from '../components/Reports.vue';

export default {
  components: { ReportingApi, Reports },

  methods: {
    dateForSecsAgo(uptimeInSeconds, onlyTime) {
      return moment().utc().subtract(uptimeInSeconds, 'seconds').format(onlyTime ? 'HH:mm:ss' : 'DD/MM/YYYY h:mm:ss a');
    },
    humanDateForSecsAgo(uptimeInSeconds) {
      return moment.duration(uptimeInSeconds, 'seconds').humanize();
    },
  },
};
</script>

<style scoped>
.card {
  margin-bottom: 5px;
}
</style>
